// extracted by mini-css-extract-plugin
module.exports = {"listHeader":"ManageAdmins_listHeader__3eJFi","addAdminButton":"ManageAdmins_addAdminButton__3IjpC"};